import { safeApiRequest } from './apiClient';

export const PARCA_GONDERIM_SAYAC_YENILE_EVENT = 'parca-gonderim-sayac-yenile';

export const fetchParcaGonderimler = async ({
  tab,
  yon,
  arama,
  sayfa = 1,
  limit = 20,
} = {}) => {
  const query = { sayfa, limit };
  if (tab) query.tab = tab;
  if (yon) query.yon = yon;
  if (arama && String(arama).trim()) query.arama = String(arama).trim();
  return safeApiRequest('/api/parca-gonderimler', { method: 'GET', query, skipCsrf: true });
};

export const fetchParcaGonderimSekmeSayilari = async () => {
  return safeApiRequest('/api/parca-gonderimler/sekme-sayilari', { method: 'GET', skipCsrf: true });
};

export const fetchParcaGonderimDetay = async (id) => {
  return safeApiRequest(`/api/parca-gonderimler/${encodeURIComponent(id)}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

export const createParcaGonderim = async ({ gonderenTeknikServisId, aliciTeknikServisId, pozisyonlar, not }) => {
  return safeApiRequest('/api/parca-gonderimler', {
    method: 'POST',
    body: { gonderenTeknikServisId, aliciTeknikServisId, pozisyonlar, not },
  });
};

export const onaylaParcaGonderim = async (id) => {
  return safeApiRequest(`/api/parca-gonderimler/${encodeURIComponent(id)}/onayla`, {
    method: 'PATCH',
  });
};

export const parcaGonderimKargoGir = async (id, { kargoFirmasi, kargoTakipNo }) => {
  return safeApiRequest(`/api/parca-gonderimler/${encodeURIComponent(id)}/kargo`, {
    method: 'PATCH',
    body: { kargoFirmasi, kargoTakipNo },
  });
};

export const parcaGonderimTeslimAl = async (id) => {
  return safeApiRequest(`/api/parca-gonderimler/${encodeURIComponent(id)}/teslim-al`, {
    method: 'PATCH',
  });
};

/** Sidebar rozeti: TP tarafında kargo/teslim bekleyen işlemler */
export const fetchParcaGonderimSidebarBadgeSayisi = async (rol) => {
  try {
    const res = await fetchParcaGonderimSekmeSayilari();
    const v = res?.veri;
    if (!v || typeof v !== 'object') return 0;
    const r = (rol || '').toLowerCase();
    if (r === 'admin') {
      return 0;
    }
    if (r === 'tech-service' || r === 'teknikservis' || r === 'techservice') {
      return (v.gidenAksiyon ?? v.giden ?? 0) + (v.gelenAksiyon ?? v.gelen ?? 0);
    }
    return 0;
  } catch {
    return 0;
  }
};

export const dispatchParcaGonderimSayacYenile = () => {
  window.dispatchEvent(new CustomEvent(PARCA_GONDERIM_SAYAC_YENILE_EVENT));
};
